export default {
  init () {
    // Conditional required fields for company registration
    const $userTypeSelect = $('#user-type-select');
    const $companyFields = $('.company_fields');
    const $companyInput = $('#company');
    const $vatInput = $('#billing_vat_number');

    function toggleCompanyFields() {
      const userType = $userTypeSelect.val();

      if (userType === 'company') {
        $companyFields.show();
        // Add required attribute
        $companyInput.prop('required', true);
        $vatInput.prop('required', true);
        // Add visual asterisk to labels if not present
        $companyFields.find('label').each(function() {
          const $label = $(this);
          if ($label.find('.required').length === 0) {
            $label.append('&nbsp;<abbr class="required" title="required">*</abbr>');
          }
        });
      } else {
        $companyFields.hide();
        // Remove required attribute
        $companyInput.prop('required', false);
        $vatInput.prop('required', false);
        // Remove visual asterisk
        $companyFields.find('label .required').remove();
      }
    }

    // Initialize on page load if select exists
    if ($userTypeSelect.length) {
      toggleCompanyFields();

      // Update on change
      $userTypeSelect.on('change', toggleCompanyFields);
    }
  },
}



// WEBPACK FOOTER //
// ./scripts/routes/myaccount.js